import { PluginContainerData, Link } from "./common";
import { ButtonData_Type } from "./plugin_button.enums";
function buttonData_TypeFromJSON(object) {
  switch (object) {
    case 0:
    case "LINK":
      return ButtonData_Type.LINK;
    case 1:
    case "ACTION":
      return ButtonData_Type.ACTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ButtonData_Type.UNRECOGNIZED;
  }
}
function buttonData_TypeToJSON(object) {
  switch (object) {
    case ButtonData_Type.LINK:
      return "LINK";
    case ButtonData_Type.ACTION:
      return "ACTION";
    default:
      return "UNKNOWN";
  }
}
const baseButtonData = { type: ButtonData_Type.LINK };
const ButtonData = {
  fromJSON(object) {
    const message = { ...baseButtonData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.type = object.type !== void 0 && object.type !== null ? buttonData_TypeFromJSON(object.type) : ButtonData_Type.LINK;
    message.styles = object.styles !== void 0 && object.styles !== null ? ButtonData_Styles.fromJSON(object.styles) : void 0;
    message.text = object.text !== void 0 && object.text !== null ? String(object.text) : void 0;
    message.link = object.link !== void 0 && object.link !== null ? Link.fromJSON(object.link) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.type !== void 0 && (obj.type = buttonData_TypeToJSON(message.type));
    message.styles !== void 0 && (obj.styles = message.styles ? ButtonData_Styles.toJSON(message.styles) : void 0);
    message.text !== void 0 && (obj.text = message.text);
    message.link !== void 0 && (obj.link = message.link ? Link.toJSON(message.link) : void 0);
    return obj;
  }
};
const baseButtonData_Styles = {};
const ButtonData_Styles = {
  fromJSON(object) {
    const message = { ...baseButtonData_Styles };
    message.border = object.border !== void 0 && object.border !== null ? ButtonData_Styles_Border.fromJSON(object.border) : void 0;
    message.colors = object.colors !== void 0 && object.colors !== null ? ButtonData_Styles_Colors.fromJSON(object.colors) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.border !== void 0 && (obj.border = message.border ? ButtonData_Styles_Border.toJSON(message.border) : void 0);
    message.colors !== void 0 && (obj.colors = message.colors ? ButtonData_Styles_Colors.toJSON(message.colors) : void 0);
    return obj;
  }
};
const baseButtonData_Styles_Colors = {};
const ButtonData_Styles_Colors = {
  fromJSON(object) {
    const message = { ...baseButtonData_Styles_Colors };
    message.text = object.text !== void 0 && object.text !== null ? String(object.text) : void 0;
    message.border = object.border !== void 0 && object.border !== null ? String(object.border) : void 0;
    message.background = object.background !== void 0 && object.background !== null ? String(object.background) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.text !== void 0 && (obj.text = message.text);
    message.border !== void 0 && (obj.border = message.border);
    message.background !== void 0 && (obj.background = message.background);
    return obj;
  }
};
const baseButtonData_Styles_Border = {};
const ButtonData_Styles_Border = {
  fromJSON(object) {
    const message = { ...baseButtonData_Styles_Border };
    message.width = object.width !== void 0 && object.width !== null ? Number(object.width) : void 0;
    message.radius = object.radius !== void 0 && object.radius !== null ? Number(object.radius) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.width !== void 0 && (obj.width = message.width);
    message.radius !== void 0 && (obj.radius = message.radius);
    return obj;
  }
};
export {
  ButtonData,
  ButtonData_Styles,
  ButtonData_Styles_Border,
  ButtonData_Styles_Colors,
  buttonData_TypeFromJSON,
  buttonData_TypeToJSON
};
//# sourceMappingURL=plugin_button.js.map
